// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"427":"a4c7892a","739":"355f18d1"}[chunkId] + ".chunk.css";
};